import Layout from 'HorizontalMenu/Menu';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Navbar, Row } from 'reactstrap';
import ToolTip from 'Components/ToolTip';
import DeletePopOver from 'Components/DeletePopOver';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { errorToast, successToast } from 'Components/Toasts';
import apiGlobal from 'global/api.global';
import { queryClient } from 'react-query/queryClient';
import EditIcon from '../Media/ED2.png';
import DeleteIcon from '../Media/delete.png';
import { RootState } from 'index';
import { useDispatch, useSelector } from 'react-redux';
import { getVesselsAction, setOnboardedVessels } from 'Store/Generic/ReportingSlice';
import { OnboardingStatus } from 'shared/constants';
import PopUp from 'Components/PopUp';
import EditFleetPopUp from './EditFleetPopUp';
import { formattooltip } from 'GenericForms/Helper';
import TableLoading from 'Components/TableLoading';
import PageNavButton from 'Dashboard/PendingFiles/PageNavButton';
import Message from 'Components/Message';

const FleetManagement = () => {
    useDocumentTitle("Fleet Management - ecoSAIL", "ecoSAIL");
    const [deleteFleetBool, setDeleteFleetBool] = useState(false);
    const [createModalState, setCreateModalState] = useState(false);
    const [refreshKey_2, setRefreshKey_2] = React.useState<number>(0);
    const [target, setTarget] = useState<string>('');
    const [hoverId, setHoverId] = useState<string>('');
    const [fleetId, setFleetId] = useState(null);
    const [cachedFleets, setCachedfleets] = useState<any>(null);
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);
    const [pageUrl, setPageUrl] = useState(queryKeyes.fleets.fleetCount.url());
    const { Vessels } = useSelector(
        (state: RootState) => state.Reporting
    );
    const dispatch = useDispatch();
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);

    /** Effect 2: Set onboarded vessels when Vessels data is available */
    useEffect(() => {
        if (Array.isArray(Vessels)) {
            const onboardedVessels = Vessels.filter(
                (vessel) => vessel.onboarding_status === OnboardingStatus.ONBOARDED
            );
            dispatch(setOnboardedVessels(onboardedVessels));
        }
    }, [Vessels, dispatch]);
    /** Fleet management Start of useQuery
     * Querie to load fleets
     */
    const {
        data: Fleets,
        isLoading: FleetsLoading,
        isError: FleetsError,
    } = useQuery(
        [queryKeyes.fleets.fleetCount.key, refreshKey_2, pageUrl],
        async () => await Get(pageUrl),
        {
            enabled: true,
            onSuccess: (data) => {
                setInitialLoadComplete(true);
                // Update cached reports when new data arrives
                if (data?.results?.length > 0) {
                    setCachedfleets(data);
                }
            }
        }
    );
    const displayData = Fleets ?? cachedFleets;
    const page = displayData?.results;
    /** Fleet management End of useQuery */

    /** Function to delete fleet */
    const handleFleetDelete = (id: number) => {
        apiGlobal
            .delete(`/fleet_master/${id}/`)
            .then((res) => {
                if (res.status === 200 || res.status === 204) {
                    successToast("Data deleted successfully!");
                    queryClient.invalidateQueries(queryKeyes.fleets.fleetCount.key);
                    setDeleteFleetBool(false);
                    setHoverId('');
                    setRefreshKey_2(refreshKey_2 + 1);
                    /** on successfull delete set first fleet as active */
                }
            })
            .catch(() => {
                errorToast("Internal error occured, please contact the admin");
            });
    };

    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row className='mb-2'>
                        <Col>
                            <div className="d-flex justify-content-between align-items-center">
                                <h4 className="mb-0 mt-3">Fleet Management</h4>
                                <Button
                                    color="primary"
                                    onClick={() => { setCreateModalState(true); setFleetId(null); }}
                                >
                                    <i className="dripicons-plus font-size-16 align-middle me-2" />
                                    Create New
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {createModalState && (
                        <PopUp
                            state={createModalState}
                            setState={setCreateModalState}
                            body={
                                <EditFleetPopUp
                                    setRefreshKey_2={setRefreshKey_2}
                                    fleetID={fleetId}
                                    setCreateModalState={setCreateModalState}
                                    setFleetId={setFleetId}
                                />
                            }
                            title="Create Fleet"
                            size="md"
                        />
                    )}

                    {(!initialLoadComplete) && (!FleetsError) ? (
                        <TableLoading Rows={8} />
                    ) : (
                        <div className="mt-3">
                            <table className="table mb-0" key={refreshKey_2}>
                                <thead className='table-light'>
                                    <tr>
                                        <th className='p-2 align-middle text-center' style={{ width: "0%" }}>#</th>
                                        <th className='p-2 align-middle' style={{ width: "40%" }}>Fleet name</th>
                                        <th className='p-2 align-middle text-center' style={{ width: "10%" }}>Total vessels</th>
                                        <th className='p-2 align-middle text-center' style={{ width: "10%" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {page?.length > 0 ? (
                                        page.map((fleet: any, index: number) => (
                                            <tr key={fleet.fleet_id}>
                                                <td className='text-center'>{index + 1}</td>
                                                <td>{fleet.fleet_name}</td>
                                                <td className='text-center'>{fleet?.vessel_count}</td>
                                                <td className='text-center d-flex justify-content-center gap-2'>
                                                    <img
                                                        alt="Edit fleet"
                                                        className="pointer mr-1"
                                                        src={EditIcon}
                                                        height="28"
                                                        id={`Edit_Fleet_${fleet.fleet_id}`}
                                                        onClick={() => {
                                                            setFleetId(fleet.fleet_id);
                                                            setCreateModalState(true);
                                                        }}
                                                        style={{ transition: 'transform 0.2s ease', borderRadius: '4px' }}
                                                        onMouseEnter={(e) => {
                                                            (e.target as HTMLImageElement).style.transform = 'scale(1.1)';
                                                            setHoverId(`Edit_Fleet_${fleet.fleet_id}`);
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            (e.target as HTMLImageElement).style.transform = 'scale(1)';
                                                            setHoverId('');
                                                        }}
                                                    />
                                                    <img
                                                        alt="Delete fleet"
                                                        className="pointer"
                                                        src={DeleteIcon}
                                                        height="28"
                                                        id={`Delete_Fleet_${fleet.fleet_id}`}
                                                        onClick={() => {
                                                            setDeleteFleetBool(true);
                                                            setFleetId(fleet.fleet_id);
                                                            setTarget(`Delete_Fleet_${fleet.fleet_id}`);
                                                            setHoverId(null);
                                                        }}
                                                        style={{ transition: 'transform 0.2s ease', borderRadius: '4px' }}
                                                        onMouseEnter={(e) => {
                                                            (e.target as HTMLImageElement).style.transform = 'scale(1.1)';
                                                            setHoverId(`Delete_Fleet_${fleet.fleet_id}`);
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            (e.target as HTMLImageElement).style.transform = 'scale(1)';
                                                            setHoverId('');
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4} >
                                                <Message message='No fleets found' type='warning' width='475px' />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={5} className="p-2 ">
                                            <PageNavButton
                                                setPageUrl={setPageUrl}
                                                pageobj={displayData}
                                                pageUrl={pageUrl}
                                                isLoading={FleetsLoading}
                                            />
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    )}
                    {deleteFleetBool &&
                        <DeletePopOver
                            state={deleteFleetBool}
                            setState={setDeleteFleetBool}
                            target={target}
                            message='Are you sure you want to delete this fleet?'
                            onClick={() => {
                                handleFleetDelete(fleetId)
                                setRefreshKey_2(refreshKey_2 + 1)
                            }}
                        />
                    }
                    {hoverId && document.getElementById(hoverId) !== null &&
                        <ToolTip
                            target={hoverId}
                            message={formattooltip(hoverId)}
                            isOpen={hoverId ? true : false}
                            tooltipKey={refreshKey_2}
                        />
                    }
                </Container>
            </div>
        </React.Fragment>
    );
};

export default FleetManagement;